import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { setBookingData } from "../../../redux/actions/dbactions/pateints";
import { rescheduleOrder } from "../../../redux/actions/dbactions/orderActions";

const Reschedule = ({
  show,
  onHide,
  selectedID,
  selectedDate,
  selectedTime,
  userName,
}) => {
  const dispatch = useDispatch();
  const [selectedColor, setSelectedColor] = useState(selectedTime);
  const [isDisabled, setIsDisabled] = useState(true);
  const [datebook, setDatebook] = useState(selectedDate);
  const [time, setTime] = useState(selectedTime);

  const handledateinput = (e) => {
    setDatebook(e.target.value);
    setIsDisabled(false);
  };

  const handleClick = async (calValue, label) => {
    const data = {
      ord_svc_date: datebook,
      ord_svc_time: label,
    };
    setSelectedColor(calValue);
    setTime(label);
    dispatch(setBookingData(data));
    setIsDisabled(false);
  };

  useEffect(() => {
    setSelectedColor(selectedTime);
    setDatebook(selectedDate);
  }, [selectedID, selectedDate, selectedTime]);

  const intervalsArray = [
    { ID: "svc_cal_01", label: "00:00 to 01:00" },
    { ID: "svc_cal_02", label: "01:00 to 02:00" },
    { ID: "svc_cal_03", label: "02:00 to 03:00" },
    { ID: "svc_cal_04", label: "03:00 to 04:00" },
    { ID: "svc_cal_05", label: "04:00 to 05:00" },
    { ID: "svc_cal_06", label: "05:00 to 06:00" },
    { ID: "svc_cal_07", label: "06:00 to 07:00" },
    { ID: "svc_cal_08", label: "07:00 to 08:00" },
    { ID: "svc_cal_09", label: "08:00 to 09:00" },
    { ID: "svc_cal_10", label: "09:00 to 10:00" },
    { ID: "svc_cal_11", label: "10:00 to 11:00" },
    { ID: "svc_cal_12", label: "11:00 to 12:00" },
    { ID: "svc_cal_13", label: "12:00 to 13:00" },
    { ID: "svc_cal_14", label: "13:00 to 14:00" },
    { ID: "svc_cal_15", label: "14:00 to 15:00" },
    { ID: "svc_cal_16", label: "15:00 to 16:00" },
    { ID: "svc_cal_17", label: "16:00 to 17:00" },
    { ID: "svc_cal_18", label: "17:00 to 18:00" },
    { ID: "svc_cal_19", label: "18:00 to 19:00" },
    { ID: "svc_cal_20", label: "19:00 to 20:00" },
    { ID: "svc_cal_21", label: "20:00 to 21:00" },
    { ID: "svc_cal_22", label: "21:00 to 22:00" },
    { ID: "svc_cal_23", label: "22:00 to 23:00" },
    { ID: "svc_cal_24", label: "23:00 to 24:00" },
  ];

  const labelMapping = {};
  intervalsArray.forEach((item) => {
    labelMapping[item.ID] = item.label;
  });

  const ClosePop = () => {
    setSelectedColor(selectedTime);
    setDatebook(selectedDate);
    setIsDisabled(true);
    onHide();
  };

  const bookInfo = () => {
    dispatch(rescheduleOrder(selectedID, datebook, time));
  };

  return (
    <Modal
      className="edit_modal profile"
      show={show}
      onHide={ClosePop}
      centered
    >
      <Modal.Header closeButton>
        <h5 className="mb-0">{`Select a slot for ${userName}`}</h5>
      </Modal.Header>

      <Modal.Body>
        <input
          type="date"
          className="form-control mb-3"
          style={{ cursor: "pointer" }}
          value={datebook}
          onChange={handledateinput}
        />
        <div className="hoverSlect !grid-cols-2 sm:!grid-cols-3 whitespace-nowrap px-0">
          {intervalsArray.map((item) => (
            <button
              key={item.ID}
              className={selectedColor === item.ID ? "selectedActive" : ""}
              onClick={() => handleClick(item.ID, item.label)}
            >
              {item.label}
            </button>
          ))}
        </div>

        <Row>
          <Col>
            <div className="mini_edit justify-end">
              <Button
                className="w-full !rounded-md bg-transparent h-[43px] !max-w-28 !border-b-color text-black !text-sm"
                variant="secondary"
                onClick={ClosePop}
              >
                Cancel
              </Button>
              <Button
                className="w-full !rounded-md !max-w-28 !text-sm !bg-primary-blue h-[43px] !border-primary-blue"
                variant="primary"
                type="submit"
                onClick={bookInfo}
                disabled={isDisabled}
              >
                Reschedule
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export { Reschedule };
